/**
 * Mailer Campaign List Component
 */
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import EyeIcons from '@/icons/EyeIcons'
import { paths } from '@/utils/path'
import { useNavigate } from 'react-router-dom'
import type { MailerCampaign } from '../../types'
import { useMailerCampaignList } from '../../hooks/use-mailer-campaign-list'

const CampaignList: React.FC = () => {
    const navigate = useNavigate()

    const {
        campaigns,
        pagination,
        stateComponent,
        params,
        searchInputProps,
        columns,
        handlePageChange,
        handlePageSizeChange,
        handleSortChange,
        t,
    } = useMailerCampaignList()

    return (
        <Paper className="space-y-2 my-2">
            {stateComponent || (
                <DataTableCustomized<MailerCampaign>
                    columns={columns}
                    rows={campaigns}
                    rowKey={(row) => row.mailer_campaign_id}
                    size="small"
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('mailerCampaign:search_campaign'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'mailer-campaign-list',
                        },
                    }}
                    stickyHeader={{
                        enabled: true,
                        offsetTopSelector: '#main-header',
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    actions={[
                        {
                            key: 'view',
                            label: t('view'),
                            icon: <EyeIcons />,
                            onClick: (row) =>
                                navigate(
                                    paths.mailerCampaignDetail.replace(
                                        ':id',
                                        String(row.mailer_campaign_id)
                                    )
                                ),
                        },
                    ]}
                />
            )}
        </Paper>
    )
}

export default CampaignList
